import { useEffect, useState } from "react";
import { ModuleStatuses, ModuleTypeId } from "../types/DBTables";
import { useGlobalData } from "../components/GlobalDataProvider";
import { DTOBuilding, DTOModule } from "../types/building";
import { Route, Routes, useNavigate, useParams } from "react-router-dom";
import WizardStepConfigurator from "../components/BuildingWizard/WizardStepConfigurator";
import { useWizardHandler } from "../modules/WizardHandler";

const createDefaultWizardBuilding = () => {
  let m1 = {
    moduleTypeId: ModuleTypeId.Byggnadsdata,
    name: "Byggnadsdata & energistatistik",
    data: "{}",
    status: ModuleStatuses.Created,
    id: -1,
  } as DTOModule;

  let m2 = {
    moduleTypeId: ModuleTypeId.Lokaler,
    name: "Lokaler & rum",
    data: "{}",
    status: ModuleStatuses.Configured,
    id: -2,
  } as DTOModule;

  let b = {
    id: -1,
    customerId: -1,
    name: "",
    modules: [m1, m2],
    createdDate: new Date(),
  } as DTOBuilding;

  return b;
};

const BuildingWizard = () => {
  const [wizardBuilding, setWizardBuilding] = useState<DTOBuilding | undefined>(undefined);
  const { buildingId } = useParams();
  const wizardHandler = useWizardHandler();

  const navigate = useNavigate();
  const globalData = useGlobalData();

  useEffect(() => {
    let building: DTOBuilding;
    if (buildingId) {
      let b = globalData.buildings?.find((b) => b.id === parseInt(buildingId)) as DTOBuilding;
      if (!b) b = createDefaultWizardBuilding();
      else b = { ...b };
      building = b;
    } else {
      building = createDefaultWizardBuilding();
    }

    wizardHandler.startWizard(building, globalData.moduleTypes);
    setWizardBuilding(building);
  }, []); // Or [] if effect doesn't need props or state

  const onGoToStartWizard = () => {
    navigate("" + 1);
  };

  const onCancel = () => {
    navigate("..");
  };

  //First render reads building data from last used building if not stopped
  if (wizardBuilding === undefined) return <></>;

  return (
    <Routes>
      <Route element={<WizardStepConfigurator />} path="/:wizardStep/" />
      <Route
        element={
          <>
            <div className="d-grid gap-2 d-md-flex">
              <button type="button" className={"btn btn-secondary "} onClick={onGoToStartWizard}>
                Starta Wizard
              </button>
              <button type="button" className={"btn btn-primary "} onClick={onCancel}>
                Avbryt
              </button>
            </div>
          </>
        }
        path="*"
      />
    </Routes>
  );
};

export default BuildingWizard;
